export default __webpack_public_path__ + "static/media/logo_anthem.26b99320.svg";